var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 261,
    viewBox: "0 0 273 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_219_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.996 130.5C260.996 58.4268 202.57 0 130.498 0C58.4259 0 0 58.4268 0 130.5C0 202.573 58.4259 261 130.498 261C202.57 261 260.996 202.573 260.996 130.5Z",
    fill: "#00397D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.372 86.5258C105.911 85.9871 106.551 85.5598 107.254 85.2682C107.958 84.9767 108.713 84.8267 109.474 84.8267C110.236 84.8267 110.991 84.9767 111.694 85.2682C112.398 85.5598 113.038 85.9871 113.576 86.5258C114.115 87.0645 114.542 87.704 114.834 88.4078C115.125 89.1117 115.276 89.866 115.276 90.6278C115.276 91.3897 115.125 92.144 114.834 92.8478C114.542 93.5517 114.115 94.1912 113.576 94.7299L100.274 108.023H150.072C154.642 108.023 159.167 108.924 163.389 110.672C167.612 112.421 171.448 114.985 174.679 118.216C177.911 121.448 180.474 125.284 182.223 129.506C183.972 133.728 184.872 138.253 184.872 142.823C184.872 147.393 183.972 151.919 182.223 156.141C180.474 160.363 177.911 164.199 174.679 167.431C171.448 170.662 167.612 173.226 163.389 174.975C159.167 176.723 154.642 177.623 150.072 177.623H121.071C119.533 177.623 118.058 177.012 116.97 175.924C115.882 174.837 115.271 173.361 115.271 171.823C115.271 170.284 115.882 168.809 116.97 167.721C118.058 166.633 119.533 166.022 121.071 166.022H150.072C153.119 166.022 156.135 165.422 158.95 164.256C161.764 163.09 164.322 161.382 166.476 159.227C168.63 157.073 170.339 154.516 171.505 151.701C172.67 148.887 173.27 145.87 173.27 142.823C173.27 139.777 172.67 136.76 171.505 133.946C170.339 131.131 168.63 128.574 166.476 126.42C164.322 124.265 161.764 122.557 158.95 121.391C156.135 120.225 153.119 119.625 150.072 119.625H100.274L113.572 132.923C114.66 134.011 115.271 135.486 115.271 137.025C115.271 138.564 114.66 140.039 113.572 141.127C112.484 142.215 111.009 142.826 109.47 142.826C107.932 142.826 106.456 142.215 105.368 141.127L82.1743 117.924C81.6353 117.386 81.2077 116.746 80.916 116.042C80.6243 115.338 80.4741 114.584 80.4741 113.822C80.4741 113.06 80.6243 112.306 80.916 111.602C81.2077 110.898 81.6353 110.258 82.1743 109.72L105.372 86.5258Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_219_121",
    x: -8,
    y: -8,
    width: 280.996,
    height: 281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.325 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_219_121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_219_121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.67d56f4f31e56fa81fd2eacc7b5377c2.svg";
export { ForwardRef as ReactComponent };